import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

const DialogDeleteSplit = ({ open, onDialogClose, onSubmit }) => {
    const [openModal, setOpenModal] = useState(false);

    const handleClose = () => {
        setOpenModal(false);
        onDialogClose()
    };

    const handleSubmit = () => {
        setOpenModal(false);
        onDialogClose()
        onSubmit()
    };

    useEffect(() => {
        setOpenModal(open)
    }, [open])

    return (
        <Dialog
            open={openModal}
            onClose={handleClose}
            aria-labelledby="Supprimer un split"
            aria-describedby="description"
            color='error'

        >
            <DialogTitle id="alert-dialog-title">
                Supprimer ce split
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    Voulez-vous vraiment supprimer ce split ? Attention, cette action est irréversible, il n'y a aucun moyen de récupérer les données une fois supprimées.                    </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} autoFocus>Annuler</Button>
                <Button variant='contained' onClick={() => handleSubmit()} color='error'>
                    Supprimer
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default DialogDeleteSplit;